import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useOrganization } from "../../configurations/OrganizationContext";
import { MANASWINI_LOGO } from "../../shared/constants/manaswinilogo";
import {
  HOSPITAL_ADDRESS,
  HOSPITAL_DESC,
  HOSPITAL_NAME,
} from "../../shared/constants";


import htmlToPdfmake from "html-to-pdfmake";

import {
ORG_CODES
} from "../../shared/constants"

const rich = (html) => {
  if (!html || typeof html !== "string") return [{ text: "" }];

  const cleaned = html.replace(/<p><br\s*\/?><\/p>/gi, "");
  if (!cleaned.trim()) return [{ text: "" }];
  const result = htmlToPdfmake(cleaned, {
    defaultStyles: {
      b: { bold: true },
      strong: { bold: true },
      i: { italics: true },
      em: { italics: true },
      u: { decoration: "underline" },
      s: { decoration: "lineThrough" },
      p: { margin: [0, 0, 0, 2] },
    },
  });
  return Array.isArray(result) ? result : [result];
};

const plainText = (html) => {
  if (!html || typeof html !== "string") return "";
  return html
    .replace(/<\/p>/g, "\n")
    .replace(/<br\s*\/?>/g, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&amp;/g, "&")
    .replace(/&bull;/g, "•")
    .replace(/&nbsp;/g, " ")
    .replace(/\n+/g, "\n")
    .trim();
};

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const qz = require("qz-tray");

function PrintDischargeSummary(props) {
  const org = useOrganization();
  const printerName = process.env.REACT_APP_PRINTER_NAME;
  console.log("data to get ... :", props, props.summary.dischargedt);
  console.log("doctorList : ", props.doctorList);
  const teleConsultDoctors = props.teleConsultDoctors || [];

  var id = props.patientdetails.resCb.id ? props.patientdetails.resCb.id : "";
 var patient_title = props.summary["patient title"] || "";
var patient_name =
  props.patientdetails.resCb.fname ||
  props.patientdetails.resCb.mname ||
  props.patientdetails.resCb.lname
    ? patient_title + " " +
      props.patientdetails.resCb.fname +
      " " +
      props.patientdetails.resCb.mname +
      " " +
      props.patientdetails.resCb.lname
    : "";
  var IP_number = props?.patientdetails?.resCb?.visit?.ipopnumber
    ? props?.patientdetails?.resCb?.visit?.ipopnumber
    : "";
  var Admission_type = props.summary["Admission Type"];
  var Age = props.patientdetails.resCb.age ? props.patientdetails.resCb.age : "";
  var gender = props.patientdetails.resCb.gender ? props.patientdetails.resCb.gender : "";
  var DATE_of_discharge = "";
  var KSMHA_intimation_number = props.summary["Ksmha Intimation Number"];

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  var supportDate = props.summary["supportDate"];
  var mhrbValueText =
    Admission_type === "Supported" || Admission_type === "support"
      ? `Yes\n${formatDate(supportDate)}\n${KSMHA_intimation_number || ""}`
      : `No\n\n${KSMHA_intimation_number || ""}`;

  var Nominated_Representive = props.summary["Nominated Representative"];
  const city = props.patientdetails.resCb.city;
  const state = props.patientdetails.resCb.state;
  const pincode = props.patientdetails.resCb.pincode;
  var Address =
    (props.patientdetails.address !== null &&
      props.patientdetails.resCb.address !== "" &&
      props.patientdetails.resCb.address !== undefined
      ? props.patientdetails.resCb.address + ", "
      : "") +
    (city ? city : "Arkula") +
    (state ? ", " + state : ", Karnataka") +
    (pincode ? " " + pincode : "");

  var CnfrmNumber = props.summary["Appointment Confirmation Number"];
  const contctNumber = "+91 " + process.env.REACT_APP_EMERGENCY_NUNBER;

  var folloUp = "";
  if (props.revisitDetails) {
    const followupDate = new Date(props.revisitDetails);
    folloUp = followupDate.toLocaleDateString("en-GB");
  } else {
    folloUp = "Weekly";
  }

  if (props.summary.dischargedt) {
    const date = new Date(props.summary.dischargedt);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      weekday: "short", month: "short", day: "numeric",
      year: "numeric", hour: "numeric", minute: "numeric",
    }).format(date);
    DATE_of_discharge = formattedDate || "";
  } else {
    const date = new Date();
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      weekday: "short", month: "short", day: "numeric",
      year: "numeric", hour: "numeric", minute: "numeric",
    }).format(date);
    DATE_of_discharge = formattedDate || "";
  }

  const inputDate = new Date(props?.patientdetails?.resCb?.visit?.admsnDate);
  const formattedDate = inputDate.toLocaleString("en-US", {
    weekday: "short", year: "numeric", month: "short",
    day: "numeric", hour: "numeric", minute: "numeric",
  });
  var Date_of_addmission = formattedDate || "";
  var PHONE_NO = props.patientdetails.resCb.phno ? props.patientdetails.resCb.phno : "";

  const roomList = props?.patientdetails?.resCb?.roomList || [];
  const Room_number = roomList
    .map((room) =>
      room.floorId ? `Floor ${room.floorId} - ${room.roomName}` : room.roomName
    )
    .join(", ");

  var education = props?.patientdetails?.resCb?.education;
  var occupation = props?.patientdetails?.resCb?.occupation;
  var consult_Doctor =
    org.consultionInDischargeSummary?.split(",").map((d) => d.trim()) || [];

  useEffect(() => {
    props.parentCallBack();
    dischargeSummaryPrint();
  }, []);

  const medicines = props.summary["Advice on discharge"] || [];
  const medicineTable =
    medicines.length > 0
      ? {
        table: {
          widths: ["*", "*", "*", "*"],
          margin: [0, 0, 0, 0],
          body: medicines.map((m, index) => {
            const isLast = index === medicines.length - 1;

            return [
              { text: m.medicine || "", border: [false, false, true, !isLast] },
              { text: m.dose || "", border: [false, false, true, !isLast] },
              { text: m.frequency || "", border: [false, false, true, !isLast] },
              { text: m.comment || "", border: [false, false, false, !isLast] },
            ];
          }),
        },
      }
      : { text: "" };

  const extractData = () => {
    return {
      pageMargins: [40, 144, 40, 55],
      content: [
        {
          text: "DISCHARGE SUMMARY",
          style: "pageTitle",
          alignment: "center",
          margin: [0, 0, 0, 3],
        },

        // ── TABLE 1: Patient Info ──────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [170, 100, 120, 100],
            body: [
              [
                { text: "PATIENT NAME", style: "center", fillColor: "lightgray" },
                { colSpan: 3, text: patient_name },
                "", "",
              ],
              [
                { text: "MAIN", style: "center", fillColor: "lightgray" },
                id,
                { text: "DATE OF ADMISSION", fillColor: "lightgray" },
                Date_of_addmission,
              ],
              [
                { text: "AGE / GENDER", fillColor: "lightgray" },
                `${Age} / ${gender}`,
                { text: "DATE OF DISCHARGE", fillColor: "lightgray" },
                DATE_of_discharge,
              ],
              [
                { text: "I P. NUMBER", style: "center", fillColor: "lightgray" },
                IP_number,
                { text: "ADMISSION TYPE", fillColor: "lightgray" },
                Admission_type,
              ],
              [
                {
                  text: "MHRB / INTIMATION NUMBER\nDate : ",
                  style: "center",
                  fillColor: "lightgray",
                  alignment: "left",
                },
                mhrbValueText,
                {
                  text: "NOMINATED REPRESENTATIVE\n(Name & Relation with Aadhar No:)",
                  fillColor: "lightgray",
                },
                Nominated_Representive,
              ],
              [
                { text: "ADDRESS", style: "center", fillColor: "lightgray" },
                Address,
                { text: "PHONE NO. :", fillColor: "lightgray" },
                PHONE_NO,
              ],
              [
                {
                  text: "CATEGORY OF STAY\nWARD / ROOM NUMBER",
                  style: "center",
                  fillColor: "lightgray",
                },
                Room_number,
                { text: "PACKAGE OF STAY \n(IF APPLICABLE )", fillColor: "lightgray" },
                // Package of Stay is plain TextField (not Quill), plain text is fine
                props.summary["Package of Stay"] || "",
              ],
              [
                {
                  text: "DIAGNOSIS WITH ICD-10/11 CODE",
                  style: "center",
                  fillColor: "lightgray",
                },
                {
                  colSpan: 3,
                  // ✅ rich() renders bold/italic/color from Quill
                  stack: rich(props.summary["Final Diagnosis"]),
                },
                "", "",
              ],
            ],
          },
        },

        // ── TABLE 2: Chief Complaints / Clinical Summary / Stressors ──────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            heights: [10, 20, 20],
            widths: [170, 338],
            body: [
              [
                {
                  text: "CHIEF COMPLAINTS / TARGET SYMPTOMS ( WITH DURATION )",
                  fillColor: "lightgray",
                },
                {
                  text: "CLINICAL HISTORY",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [
                // ✅ rich() for both Quill fields — bold/color/underline now rendered
                { stack: rich(props.summary["Chief Complaints"]) },
                { stack: rich(props.summary["Clinical Summary"]) },
              ],
              [
                {
                  colSpan: 2,
                  // ✅ Stressors is also a Quill field
                  stack: [
                    { text: "STRESSORS - ", bold: false, fontSize: 10 },
                    ...rich(props.summary["Stressors"]),
                  ],
                },
                "",
              ],
            ],
          },
        },


        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            heights: [20, 20, 20, 20, 20],
            widths: [170, 338],
            body: [
              [
                { text: "PAST HISTORY", fillColor: "lightgray" },
                { stack: rich(props.summary["Past and Treatment History"]) },
              ],
              [
                { text: "MEDICAL HISTORY", alignment: "start", fillColor: "lightgray" },
                { stack: rich(props.summary["Relevant Medical History"]) },
              ],
              [
                { text: "FAMILY HISTORY", alignment: "start", fillColor: "lightgray" },
                { stack: rich(props.summary["Relevant Family History"]) },
              ],
              [
                {
                  text: "PERSONAL HISTORY( INCLUDE ALLERGIES ),\nINCLUDE SUBSTANCE USE",
                  alignment: "start",
                  fillColor: "lightgray",
                },
                { stack: rich(props.summary["Personal History"]) },
              ],
              [
                {
                  text: "EDUCATIONAL & OCCUPATIONAL HISTORY (REPORTED / NIL REPORTED)",
                  alignment: "start",
                  fillColor: "lightgray",
                },
                {
                  stack: [
                    education || "Nil Significant",
                    occupation || "Nil Significant",
                  ],
                },
              ],
              [
                { text: "FORENSIC HISTORY", alignment: "start", fillColor: "lightgray" },
                { stack: rich(props.summary["Forensic History"]) },
              ],
              [
                { text: "PREMORBID PERSONALITY", alignment: "start", fillColor: "lightgray" },
                { stack: rich(props.summary["Premorbid Personality"]) },
              ],
              [
                {
                  text: "GENERAL PHYSICAL EXAMINATION INCLUDING VITALS",
                  fillColor: "lightgray",
                },
                { stack: rich(props.summary["General physical examination"]) },
              ],
              [
                { text: "SYSTEMIC EXAMINATION", fillColor: "lightgray" },
                { stack: rich(props.summary["Systemic Examination"]) },
              ],
              [
                {
                  text: "MENTAL STATUS EXAMINATION\nABLE TO / UNABLE TO GIVE INFORMED CONSENT",
                  fillColor: "lightgray",
                },
                { stack: rich(props.summary["Mental State Examination"]) },
              ],
              [
                { text: "CAPACITY ASSESSMENT", fillColor: "lightgray" },
                { stack: rich(props.summary["Capacity Assessment"]) },
              ],
              [
                { text: "CLINICAL INVESTIGATIONS", fillColor: "lightgray" },
                { stack: rich(props.summary["Clinical Investigations"]) },
              ],
              [
                {
                  text: "OTHER REPORTS \n(CT /MRI/ EEG/ SPECIAL INVESTIGATIONS / ECG )",
                  fillColor: "lightgray",
                },
                { stack: rich(props.summary["Other Reports"]) },
              ],
            ],
          },
        },


        {
          style: "fontsize",
          margin: [0, 12, 0, 10],
          table: {
            heights: [10, 30],
            widths: [516],
            body: [
              [
                {
                  text: "COURSE AND MANAGEMENT IN THE HOSPITAL",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [{ stack: rich(props.summary["Course of treatment in hospital"]) }],
            ],
          },
        },


        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            heights: [20, 20, 20, 20, 20],
            widths: [170, 338],
            body: [
              [
                {
                  text: "OTHER CONSULTATION \n(if any)\n",
                  style: "top",
                  fillColor: "lightgray",
                },
                { stack: rich(props.summary["Other Consultation"]) },
              ],
            ],
          },
        },


        // TABLE 1: Advice on Discharge
        {
          style: "fontsize",
          margin: [0, 0, 0, 0],
          table: {
            widths: [516],
            body: [
              [
                {
                  columns: [
                    { text: "ADVICE ON DISCHARGE \n Rx \t (MEDICINES)", alignment: "center" },

                  ],
                  fillColor: "lightgray",
                },
              ],
              [
                {
                  stack: [medicineTable],
                  margin: [0, 0, 0, 0],
                  border: [true, true, true, true],
                },
              ],
            ],
          },
        },

        // TABLE 2: Planned Psycho-Social Intervention
        {
          style: "fontsize",
          margin: [0, 0, 0, 0],
          table: {
            widths: [516],
            //headerRows: 1,        // ← ADD THIS — repeats heading row on every page
            body: [
              [
                {
                  text: "PLANNED PSYCHO-SOCIAL INTERVENTION",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [
                {
                  text: plainText(props.summary["Planned Psycho-Social Intervention"]),
                  fontSize: 10,
                  margin: [1, 5, 1, 5],
                  border: [true, true, true, true],
                },
              ],
            ],
          },
        },

        // TABLE 3: Relapse Prevention Measures
        {
          style: "fontsize",
          margin: [0, 0, 0, 0],
          table: {
            widths: [516],
            body: [
              [
                {
                  text: "RELAPSE PREVENTION MEASURES",
                  alignment: "center",
                  bold: true,
                  fillColor: "lightgray",
                },
              ],
              [
                {
                  text: plainText(props.summary["Relapse Prevention Measures"]),
                  fontSize: 10,
                  margin: [1, 5, 0, 1],
                  border: [true, true, true, true],
                },
              ],
            ],
          },
        },


        {
          unbreakable: true,
          text:
            "Instructions :\n•\tFew days of extra Medicines prescribed in case of need / emergency.\n•\tRisk of self harm " +
            props.summary["Risk of Self Harm"] +
            " & has been communicated to " +
            props.summary["Communicated To"] +
            ".",
          style: "fontsize",
        },
        { text: "\n", style: "fontsize" },


        // Restriction in Physical activity

        {
          text: [
            { text: "Restriction in Physical activity / Work : ", bold: true, fontSize: 10 },
            { text: plainText(props.summary["Restriction in Physical activity"]), fontSize: 10 }
          ]
        },
        { text: "\n", style: "fontsize" },

        // Diet
        {
          text: [
            { text: "DIET : ", bold: true, fontSize: 10 },
            { text: plainText(props.summary["Diet"]), fontSize: 10 }
          ]
        },
        { text: "\n", style: "fontsize" },

        // Next dose
        {
          columns: [
            {
              width: "*",
              text: [
                { text: "Next dose of long Acting Injectable (Depot) due on : ", fontSize: 10 },
                { text: plainText(props.summary["Next dose of long Acting Injectable due"]), fontSize: 10 }
              ]
            },
            {
              width: "auto",
              text: "(if applicable)",
              fontSize: 10,
              alignment: "right",
            },
          ],
        },
        { text: "\n", style: "fontsize" },
        {
          text: [{ text: "FOLLOW UP DATE: ", bold: true }, { text: folloUp }],
          style: "fontsize",
        },
        { text: "\n", style: "fontsize" },
        {
          columns: [
            { width: 30, text: "Note :", style: "fontsize", bold: true },
            {
              width: "*",
              text:
                "DON'T STOP MEDICINES ABRUPTLY.\n" +
                "TO CONTINUE TREATMENT TILL THE NEXT FOLLOW UP CONSULTATION.",
              style: "fontsize",
              bold: true,
            },
          ],
        },
        { text: "\n", style: "fontsize" },
        {
          text: [
            { text: "EMERGENCY CONTACT NUMBER: ", bold: true },
            { text: contctNumber },
          ],
          style: "fontsize",
        },
        { text: "\n", style: "fontsize" },
        {
          text: teleConsultDoctors.length > 0
            ? `Tele-consultation appointments – ${teleConsultDoctors.join(" / ")}`
            : "Tele-consultation appointments – None",
          style: "fontsize",
        },
        {
          text: "Review in Casualty in case of emergency - relapse of symptoms,harm to self or others, suicidal ideas, sleep disturbances or side-effects to medication.\n\n",
          style: "fontsize",
        },
        {
          text: "I/We have understood the instructions given about the medication dosage and post discharge care\n\n\n",
          style: "fontsize",
        },

        // ── Signature Section ─────────────────────────────────────────────
        {
          margin: [20, 5, 0, 0],
          table: {
            widths: [25, "*"],
            body: [
              // 1
              [
                { text: "1)", style: "fontsize" },
                {
                  stack: [
                    { text: "Signature :", style: "fontsize" },
                    { text: "Patient / NR / Relative", style: "fontsize" },
                    { text: "Name :", style: "fontsize" },
                    { text: "Relationship :", style: "fontsize" },
                  ],
                  margin: [0, 0, 0, 12],
                },
              ],
              // 2
              [
                { text: "2)", style: "fontsize" },
                {
                  stack: [
                    {
                      text: "Discharge summary prepared by Psychiatry Resident / Medical Officer",
                      style: "fontsize",
                    },
                    {
                      text: [
                        { text: "Name : ", style: "fontsize" },
                        { text: props.staffList?.join(", "), style: "fontsize" },
                      ],
                      margin: [0, 0, 0, 5],
                    },
                    { text: "Signature :", style: "fontsize" },
                  ],
                  margin: [0, 0, 0, 12],
                },
              ],
              // 3
              [
                { text: "3)", style: "fontsize" },
                {
                  stack: [
                    {
                      text: "Witness for handing over the discharge documents to Patient / Relative and Discharge Counselling (including Psycho education, Relapse / warning signs and Follow up procedure) done by",
                      style: "fontsize",
                    },
                    {
                      text: [
                        { text: "Name : ", style: "fontsize" },
                        { text: props.consellorlist?.join(", "), style: "fontsize" },
                      ],
                      margin: [0, 0, 0, 5],
                    },
                    { text: "Signature :", style: "fontsize" },
                  ],
                  margin: [0, 0, 0, 12],
                },
              ],
              // 4
              [
                { text: "4)", style: "fontsize" },
                {
                  stack: [
                    {
                      text: "Signature : \nConsultant Psychiatrist who is in charge of the patient during IP care",
                      style: "fontsize",
                    },
                    { text: "\n" },
                    {
                      stack: props.doctorList.map((doctor) => ({
                        text: doctor,
                        style: "fontsize",
                        bold: true,
                        margin: [0, 0, 0, 4],
                      })),
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: "(Tick the name of Treating Psychiatrist)",
                      italics: true,
                      fontSize: 9,
                      alignment: "right",
                      margin: [0, 6, 0, 0],
                    },
                  ],
                },
              ],
            ],
          },
          layout: "noBorders",
        },

        {
          text: "------------------------------------------------- x ------------------------------------------------- x -------------------------------------------------",
          margin: [0, 15, 0, 0],
        },
      ],

      footer: function (currentPage, pageCount) {
        return [
          {
            text: HOSPITAL_NAME,
            alignment: "left",
            fontSize: 6,
            color: "#176fad",
            bold: true,
            margin: [40, 10, 0, 0],
          },
          {
            text: HOSPITAL_DESC,
            alignment: "left",
            fontSize: 6,
            color: "#176fad",
            bold: true,
            margin: [40, 0, 0, 0],
          },
          {
            text: HOSPITAL_ADDRESS,
            alignment: "left",
            fontSize: 6,
            margin: [40, 0, 0, 10],
          },
        ];
      },

      styles: {
        fontsize: { fontSize: 10 },
        pageTitle: { fontSize: 13, bold: true, margin: [0, 10, 0, 5] },
      },
      defaultStyle: {},
    };
  };

  async function dischargeSummaryPrint() {
    if (org?.orgCode !== ORG_CODES.MANASWINI) {
      console.error("Invalid organization");
      return;
    }
    const docDefinition = extractData();
    printPdf(docDefinition);
  }

  function printPdf(docDefinition) {
    pdfMake.createPdf(docDefinition).open();

    pdfMake.createPdf(docDefinition).getBase64((data) => {
      qz.websocket
        .connect()
        .then(() => qz.printers.find())
        .then((printers) => {
          const printer = printers.find((p) => p.includes(printerName));
          if (!printer) throw new Error("Printer not found");
          const config = qz.configs.create(printer, {
            size: { width: 148, height: 210 },
            units: "mm",
          });
          return qz.print(config, [
            { type: "pixel", format: "pdf", flavor: "base64", data },
          ]);
        })
        .then(() => qz.websocket.disconnect())
        .catch(console.error);
    });
  }

  return null;
}

export default PrintDischargeSummary;
